// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3vosQ","productName":"Table_productName__3VgVo"};